// Shared U.S. formatting helpers for the React frontend.
// Mirrors api/src/utils/usFormat.js for server-side validation constants.

export const US_PHONE_REGEX =
  /^(\+1[-.\s]?)?(\(\d{3}\)[-.\s]?|\d{3}[-.\s]?)\d{3}[-.\s]?\d{4}$/;

export const US_ZIP_REGEX = /^\d{5}(-\d{4})?$/;

// Format a 10-digit U.S. phone as "(302) 555-0188". Falls through for inputs
// we can't confidently normalize (e.g., extensions, short codes).
export const formatUSPhone = (phone) => {
  const raw = String(phone ?? "").trim();
  if (!raw) return "";
  const digits = raw.replace(/\D/g, "");
  const ten =
    digits.length === 11 && digits.startsWith("1") ? digits.slice(1) : digits;
  if (ten.length === 10) {
    return `(${ten.slice(0, 3)}) ${ten.slice(3, 6)}-${ten.slice(6)}`;
  }
  return raw;
};

// Format a number as USD with comma thousands and exactly 2 decimals.
export const formatUSD = (amount) =>
  `$${Number(amount ?? 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

// Format a date as strict MM/DD/YYYY. Returns "" for invalid input.
export const formatUSDate = (input) => {
  if (input == null || input === "") return "";
  const d = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
};

// Format a datetime as MM/DD/YYYY, hh:mm AM/PM. Returns "" for invalid input.
export const formatUSDateTime = (input) => {
  if (input == null || input === "") return "";
  const d = input instanceof Date ? input : new Date(input);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
